/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
/* eslint-disable no-restricted-globals */
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import * as queryString from 'query-string';
import PropTypes from 'prop-types';

import SideBarV3 from './PageComponents/SideBar';
import SidebarAddEligiblePlayers from './PageComponents/SidebarAddEligiblePlayers';
import SidebarInvitePreRegistrants from './PageComponents/SidebarInvitePreRegistrants';
import EventProfileHeaderV3 from './PageComponents/EventProfileHeader';
import OverviewTabContent from './PageComponents/OverviewTabContent';
import PlayersTabContentV3 from './PageComponents/PlayersTabContentV3';
import AdminBarV3 from './PageComponents/AdminBar';
import DrawsTabContentV3 from './PageComponents/DrawsTabContentV3';
import ScheduleTabContentV2 from './PageComponents/ScheduleTabContent';
import TeamStandingsContentV2 from './PageComponents/TeamStandingsContent';
import RegConfirmationV3 from './PageComponents/RegConfirmation';
import MultiRegConfirmation from './PageComponents/RegConfirmation/MultiRegConfirmation';

import Popup from '../popup/popup';
import PublishedPopup from '../PublishedPopup/PublishedPopup';
import { ClubInactivePopup } from '../../../components/Clubs/Popups';
import PhotoEditor from '../../../components/PhotoUpload/PhotoEditor';
import GenericPopUp from '../../../components/Popup';
import { MessagePopUp, WelcomePopUp, AddEditTeamStandingPopUp } from '../../../components/PopUps';
import RegisterPlayerToEventPopUpV2 from '../../../components/PopUps/RegisterPlayerToEventPopUp/RegisterPlayerToEventPopUpV2';
import { isLoginPopUpNeeded, userParams, titles } from '../../../components/PopUps/LoginPopUpWrapper/LoginPopUp/utils';
import ShareUrlPopupNew from '../../../components/PopUps/ShareUrlPopup';
import AttachmentUploadPopup from '../../../components/PopUps/AttachmentUploadPopup';
import head from '../../../components/Meta';
import EventRegionWarningPopup from '../EventRegionWarningPopup';
import ConfirmActionPopup1Btn from '../../../components/PopUps/ConfirmActionPopup1Btn';

import * as eventProfileActions from '../../../actions/event-profile-actions';

import * as loginPopUpActions from '../../../actions/login-popup-actions';
import { showErrorPopup, showSuccessToast } from '../../../actions/notification-actions';
import { setDisableRangeSurveySkip, setSkipOnboardingIntroPopup } from '../../../actions/onboarding-actions';
import * as messagingActions from '../../../actions/messaging-actions';
import { uploadTempPhoto, clearTempPhoto } from '../../../actions/upload-actions';
import { postComponentActionPerformd } from '../../../actions/component-config-actions';

import { getEventShareURL } from '../../../utils/referrals';
import { ConversationContextTypes, MemberContextTypes, getMemberEntityObject } from '../../../utils/messaging';
import { getDefaultSortOrderForDivision, getDefaultSortParamForDivision, getDefaultSortParamForPickleballDivision, isEventDirector, isOrganizer, isVolunteer, isPickleBallSportTypeEvent, isTennisSportTypeEvent, getEventDivisionFromPlayerDivision, hasPlayerInvitationAndRegDateOpen, isEventRunning, hasAdminAddPaymentRequiredInvitation, isEventType, EventTypes, isEventPTT, isClubOrganizer } from '../../../utils/events';
import { utrTypeIds, sportTypeIds, eventStateTypeIds, drawScheduleTypeIds } from '../../../utils/eventConstants';
import { EventProfileTabIdentifiers, nonPoweredPlayerDefaultDivisionFee, ratingTypes, sortParamTypes } from '../../../utils/constants';
import { getApiAxiosInstance } from '../../../utils/network';
import { generateEventJsonLd, generateEventMetaData } from '../../../utils/seo';
import {
    AO_1_POINT_SLAM_TA_LINK_PENDING_KEY,
    getTennisAustraliaLinkError,
    hasTennisAustraliaLinkedAccount,
    requiresTennisAustraliaLinkCheck,
    shouldGateAo1PointSlamRegistration,
    shouldResumeAo1PointSlamRegistration,
    shouldShowTennisAustraliaLinkSuccessToast,
    tennisAustraliaLinkSuccessToast,
} from '../../../utils/ao1PointSlam';
import { getLinkedAccounts } from '../../../api/settingsApi';
import SplashBall from '../../../components/Splash/splashBall';
import { getPickleBallRating } from '../../../utils';
import DivisionsTabContentV4 from './PageComponents/DivisionsTabContentV4';
import EligiblePlayersTabContent from './PageComponents/EligiblePlayersTabContent';
import PreRegInvitesTabContent from './PageComponents/PreRegInvitesTabContent';
import NextAvailableLiveMatchesTabContent from './PageComponents/NextAvailableLiveMatchesTabContent';
import ProtectedTabContent from './PageComponents/ProtectedTabContent';
import { SortType } from '../../../components/ColumnHeader';
import AddWeatherUpdatePopup from '../../../components/PopUps/AddWeatherUpdatePopup';
import * as checkoutEventRegistrationApi from '../../../api/checkoutEventRegistrationApi';
import AwaitApiSuccessPopup from '../../../components/PopUps/AwaitApiSuccessPopup';
import { trackEvent } from '../../../components/Analytics/TrackedClick';
import { useBraze } from '../../../components/hooks/useBraze';
import PopupV3, { PopupTypes } from '../../../components/Popup/PopupV3';
import SidebarInvitePreRegistrantsV2 from './PageComponents/SidebarInvitePreRegistrants/SidebarInvitePreRegistrantsV2';
import { useStatsig } from '../../../components/hooks/useStatsig';
import PlayerPendingInvitations from './PageComponents/PlayerPendingInvitations';
import TennisAustraliaIdModal from '../../../components/TennisAustraliaIdModal';

import config from '../../../../config';
import { routerLocationShape, routerMatchShape, routerHistoryShape, authShape } from '../../../propTypes';

import styles from '../event.scss';

function EventProfilePageV3(props) {
    const { location, match, history, isWebView, 'data-testid': dataTestId } = props;

    const { componentConfig, uploads, auth, coreUI, splash } = useSelector(({ componentConfig, uploads, auth, coreUI, splash }) => {
        return { componentConfig, uploads, auth, coreUI, splash };
    });
    const { event, draws, currentDraw, parentDraw, players, eligiblePlayers, preRegInvites, justPublished, redirectUrl, playersTabState, regions, teamStandings, regConfirmation, eventInviteEmail, playerMessageEmail, preRegStats, preRegFilterOptions, currentMemberRegistration } = useSelector(({ eventProfile }) => {
        const { event, draws, currentDraw, parentDraw, players, eligiblePlayers, preRegInvites, justPublished, redirectUrl, playersTabState, regions, teamStandings, regConfirmation, eventInviteEmail, playerMessageEmail, preRegStats, preRegFilterOptions, currentMemberRegistration } = eventProfile;
        return {
            event,
            draws,
            currentDraw,
            parentDraw,
            players,
            eligiblePlayers,
            preRegInvites,
            preRegFilterOptions,
            justPublished,
            redirectUrl,
            playersTabState,
            regions,
            teamStandings,
            regConfirmation,
            eventInviteEmail,
            playerMessageEmail,
            preRegStats,
            currentMemberRegistration,
        };
    });
    const dispatch = useDispatch();
    const { brazeInstance, logPowerCampaignEvent, eventNames } = useBraze();
    const { birthdate, secondaryEmail, isSecondaryEmailVerified, utrRangeRequired } = auth.user || {};
    const clubStatus = event.data ? event.data.club.statusType : null;
    const clubTierType = event.data?.club?.tierType;
    const clubId = event.data?.club?.id;
    const isPttEvent = isEventPTT(event?.data);
    // eslint-disable-next-line camelcase

    const { drawsDict } = draws;
    const queryParams = useMemo(() => queryString.parse(location.search), [location.search]);

    const [showPhotoEditor, setShowPhotoEditor] = useState(false);
    const [showInactiveClubPopup, setShowInactiveClubPopup] = useState(false);
    const [isDraft, setIsDraft] = useState(false);
    const [collapsed, setCollapsed] = useState(false);
    const [publishPopover, setPublishPopover] = useState(false);
    const [showRegistrationPopup, setShowRegistrationPopup] = useState(false);
    const [handlePopupConfirm, setHandlePopupConfirm] = useState(null);
    const [registrationPopupMessage, setRegistrationPopupMessage] = useState('');
    const [inviteAllGroupMembers, setInviteAllGroupMembers] = useState(true);
    const [tabs, setTabs] = useState([
        {
            id: EventProfileTabIdentifiers.OVERVIEW,
            title: 'Overview',
            needsLogin: false,
            active: true,
            showTab: true,
        },
        {
            id: EventProfileTabIdentifiers.DIVISIONS,
            title: 'Divisions',
            needsLogin: false,
            showTab: true,
        },
        {
            id: EventProfileTabIdentifiers.PLAYERS,
            title: 'Players',
            needsLogin: true,
            showTab: true,
        },
        {
            id: EventProfileTabIdentifiers.TEAM_STANDINGS,
            title: 'Team Standings',
            needsLogin: true,
            showTab: false,
        },
        {
            id: EventProfileTabIdentifiers.DRAWS,
            title: '',
            needsLogin: true,
            showTab: false,
        },
        {
            id: EventProfileTabIdentifiers.LIVE,
            title: '',
            needsLogin: true,
            showTab: false,
        },
        {
            id: EventProfileTabIdentifiers.SCHEDULE,
            title: 'Schedule',
            needsLogin: true,
            showTab: false,
        },
        {
            id: EventProfileTabIdentifiers.ELIGIBLE_PLAYERS,
            title: 'Eligible players',
            needsLogin: true,
            showTab: false,
        },
        {
            id: EventProfileTabIdentifiers.PRE_REG_INVITES,
            title: 'Pre-reg invites',
            needsLogin: true,
            showTab: false,
        },
    ]);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [sidebarContentMounted, setSidebarContentMounted] = useState(false);
    const [sidebarFlow, setSidebarFlow] = useState('');

    useEffect(() => {
        if (sidebarOpen) {
            const t = setTimeout(() => setSidebarContentMounted(true), 0);
            return () => clearTimeout(t);
        }
        const t = setTimeout(() => setSidebarContentMounted(false), 300);
        return () => clearTimeout(t);
    }, [sidebarOpen]);
    const [showMessagePopUp, setShowMessagePopUp] = useState(false);
    const [showDemoEventIntroPopUp, setShowDemoEventIntroPopUp] = useState(true);
    const [showAddEditTeamPopUp, setShowAddEditTeamPopUp] = useState(false);
    const [selectedTeamStanding, setSelectedTeamStanding] = useState(null);
    const [showEventRegionWarningPopup, setShowEventRegionWarningPopup] = useState(false);
    const [parentGuardianPopup, setParentGuardianPopup] = useState(false);
    const [showRatingSurveyPopup, setShowRatingSurveyPopup] = useState(false);
    const [showPublishedPopup, setShowPublishedPopup] = useState(false);
    const [showShareUrlPopup, setShowShareUrlPopup] = useState(false);
    const [showShareUrlConfirmPopup, setShowShareUrlConfirmPopup] = useState(false);
    const [actionPerformed, setActionPerformed] = useState();
    const [showUploadAttachmentPopUp, setShowUploadAttachmentPopUp] = useState();
    const [showAddWeatherUpdatePopUp, setShowAddWeatherUpdatePopUp] = useState();
    const [showRegisterPlayerPopUp, setShowRegisterPlayerPopUp] = useState();
    const [notificationToEdit, setNotificationToEdit] = useState(null);
    const [pendingInvitationDivisions, setPendingInvitationDivisions] = useState([]);
    const [regPartnerAdded, setRegPartnerAdded] = useState();
    const [showAddEligiblePlayersSidebar, setShowAddEligiblePlayersSidebar] = useState(false);
    const [showInvitePreRegistrantsSidebar, setShowInvitePreRegistrantsSidebar] = useState(false);
    const [showAddEligiblePlayersError, setShowAddEligiblePlayersError] = useState(false);
    const [addEligiblePlayersErrors, setAddEligiblePlayersErrors] = useState(null);
    const [showSendPreRegistrantInviteError, setShowSendPreRegistrantInviteError] = useState(false);
    const [preRegistrantInviteErrors, setPreRegistrantInviteErrors] = useState(null);
    const [pendingAdminAddDivisions, setPendingAdminAddDivisions] = useState([]);
    const [multipleDivisionRegistrations, setMultipleDivisionRegistrations] = useState({});
    const [succesfulMultiDivisionRegistration, setSuccesfulMultiDivisionRegistration] = useState(false);
    const [focusFindPlayer, setFocusFindPlayer] = useState(false);
    const [showRegClosedPopup, setShowRegClosedPopup] = useState(false);
    const [showTennisAustraliaIdModal, setShowTennisAustraliaIdModal] = useState(false);
    const [pendingRegistrationEventId, setPendingRegistrationEventId] = useState(null);

    const downloadLink = useRef(null);
    const preRegInvitesTabRef = useRef(null);
    const hasStartedPollingRef = useRef(false);
    const pollingEventIdRef = useRef(null);
    const registrationResumedRef = useRef(false);
    const { checkGate, featureGates } = useStatsig();

    const bannerImage = event.data?.photoUrl || null;
    // const eventInviteUrl = event.data && auth.user ? getEventReferralURL(event.data, auth.user) : '';
    const eventInviteUrl = getEventShareURL(event.data);

    useEffect(() => {
        const userRegisteredDivisions = event.data?.currentMember?.registeredDivisions || [];
        const divisionsWithPendingInvitations = userRegisteredDivisions
            .filter((registeredDivision) => {
                const eventDivision = event.data?.eventDivisions.find(d => d.id === registeredDivision.id);
                return hasPlayerInvitationAndRegDateOpen(registeredDivision, eventDivision);
            })
            .map(getEventDivisionFromPlayerDivision(event.data));

        const divisionsWithPendingAdminInvitation = userRegisteredDivisions
            .filter(hasAdminAddPaymentRequiredInvitation)
            .map(getEventDivisionFromPlayerDivision(event.data)) || [];

        setPendingInvitationDivisions(divisionsWithPendingInvitations);
        setPendingAdminAddDivisions(divisionsWithPendingAdminInvitation);
    }, [event.data]);

    const isTeamLeague = isEventType(event.data, EventTypes.TEAM_LEAGUE);
    const isPaidHit = isEventType(event.data, EventTypes.PAID_HIT);
    const isFlexleagueEvent = isEventType(event.data, EventTypes.FLEX_LEAGUE);
    const isCurrentMemberAdmin = auth.user && event.data && isOrganizer(event.data);
    const isCurrentMemberVolunteer = auth.user && event.data && isVolunteer(event.data);
    const isCurrentMemberClubOrganizer = auth.user && event.data && isClubOrganizer(event.data);
    const compConfig = componentConfig?.['event-profile'];
    const demoEventIntroPopUp = compConfig?.modals.find(m => m.type === 'demo_event_intro_popup');
    const preRegMedalInvitesEnabled = checkGate(featureGates.PRE_REG_MEDAL_INVITE);
    const isAo1PointSlamTaGateEnabled = checkGate(featureGates.AO_1_POINT_SLAM_TA_GATE);

    const eventVerificationFeeParsed = event.data && parseFloat(event.data.verificationFee);
    const clubVerificationFee = eventVerificationFeeParsed >= 0 ? eventVerificationFeeParsed : nonPoweredPlayerDefaultDivisionFee;

    const activeTab = tabs.find(tab => tab.active === true);

    const loadEvent = async () => {
        await dispatch(eventProfileActions.getEvent(match.params.eventId));
        if (queryParams.d) {
            dispatch(eventProfileActions.getDrawOfficials(match.params.eventId, queryParams.d));
        }
    };

    const setInitState = async (event) => {
        if (event.data?.published && publishPopover) {
            setPublishPopover(false);
        }
        if (location.state?.adminSplash) {
            dispatch(eventProfileActions.showAdminSplash(location.state.adminSplash));
        }
        if (justPublished) {
            setShowPublishedPopup(true);
        }

        let showRegistrationSuccess = false;

        if (queryParams.checkout_id) {
            try {
                await checkoutEventRegistrationApi.legacyCheckRegistration(getApiAxiosInstance(), match.params.eventId, queryParams.checkout_id);
                showRegistrationSuccess = true;
            } catch (e) {
                dispatch(showErrorPopup({
                    message: 'Error verifying checkout',
                    error: e,
                }));
            }
        }

        if (showRegistrationSuccess || regConfirmation) {
            toRegConfirmation();
        }
        if (event.error) {
            console.log('--- currentEvent.error, redirect', event.error);
            props.history.push(redirectUrl || '/');
            return;
        }

        let tabIdentifier = parseInt(queryParams.t) || EventProfileTabIdentifiers.OVERVIEW;
        let selectedTab = tabs.find(tab => tab.id === tabIdentifier);
        if (!selectedTab) {
            // Default to Overview if the tab is not found
            tabIdentifier = EventProfileTabIdentifiers.OVERVIEW;
            selectedTab = tabs.find(tab => tab.id === tabIdentifier);
        }

        if (!auth.user && selectedTab?.needsLogin) {
            handleShowLoginPopUp(`tab-${tabIdentifier}`);
        }

        const divisionCount = event.data?.eventDivisions.filter(div => !div.isEventEntryFeeDivision).length;

        setTabs((prevTabs) => {
            const tabDetails = [
                {
                    id: EventProfileTabIdentifiers.OVERVIEW,
                    title: 'Overview',
                    needsLogin: false,
                    active: !tabIdentifier || tabIdentifier === EventProfileTabIdentifiers.OVERVIEW,
                    showTab: true,
                },
                {
                    id: EventProfileTabIdentifiers.DIVISIONS,
                    // eslint-disable-next-line prefer-template
                    title: `Divisions ${divisionCount ? '(' + divisionCount + ')' : ''}`,
                    needsLogin: false,
                    active: tabIdentifier === EventProfileTabIdentifiers.DIVISIONS,
                    showTab: true,
                },
                {
                    id: EventProfileTabIdentifiers.PLAYERS,
                    title: 'Players',
                    needsLogin: true,
                    loginMessage: 'Log in to view event players.',
                    active: tabIdentifier === EventProfileTabIdentifiers.PLAYERS,
                    showTab: true,
                },
                {
                    id: EventProfileTabIdentifiers.TEAM_STANDINGS,
                    title: 'Team Standings',
                    needsLogin: true,
                    loginMessage: 'Log in to view team standings.',
                    active: tabIdentifier === EventProfileTabIdentifiers.TEAM_STANDINGS,
                    showTab: isTeamLeague === true,
                },
                {
                    id: EventProfileTabIdentifiers.DRAWS,
                    title: isFlexleagueEvent ? 'Matchups' : 'Draws',
                    needsLogin: true,
                    loginMessage: 'Log in to view event draws.',
                    active: tabIdentifier === EventProfileTabIdentifiers.DRAWS,
                    showTab: true,
                },
                {
                    id: EventProfileTabIdentifiers.SCHEDULE,
                    title: 'Schedule',
                    needsLogin: true,
                    loginMessage: 'Log in to view event schedule.',
                    active: tabIdentifier === EventProfileTabIdentifiers.SCHEDULE,
                    showTab: !isTeamLeague && !isPaidHit,
                },
                {
                    id: EventProfileTabIdentifiers.LIVE,
                    title: 'Live',
                    needsLogin: true,
                    loginMessage: 'Log in to view live matches.',
                    active: tabIdentifier === EventProfileTabIdentifiers.LIVE,
                    showTab: event.data?.scheduleTypeId === drawScheduleTypeIds.NEXT_AVAILABLE && isEventRunning(event?.data?.eventSchedule),
                },
                {
                    id: EventProfileTabIdentifiers.ELIGIBLE_PLAYERS,
                    title: 'Eligible players',
                    needsLogin: true,
                    loginMessage: 'Log in to view eligible players.',
                    active: tabIdentifier === EventProfileTabIdentifiers.ELIGIBLE_PLAYERS,
                    showTab: isCurrentMemberAdmin && event.data?.preRegAndEligibleListEnabled && event.data?.hasEligiblePlayersList,
                },
                {
                    id: EventProfileTabIdentifiers.PRE_REG_INVITES,
                    title: 'Pre-reg invites',
                    needsLogin: true,
                    loginMessage: 'Log in to view pre-reg invites.',
                    active: tabIdentifier === EventProfileTabIdentifiers.PRE_REG_INVITES,
                    showTab: isCurrentMemberAdmin && event.data?.preRegAndEligibleListEnabled && event.data?.hasPreRegistrationInviteList,
                },
            ];
            const updatedTabs = tabDetails.map(tab => {
                const prevTab = prevTabs.find(t => t.id === tab.id);
                return prevTab ? { ...prevTab, ...tab } : tab;
            });

            const hasInvisibleActiveTab = updatedTabs.some(tab => tab.active && !tab.showTab);

            if (hasInvisibleActiveTab) {
                return updatedTabs.map(tab => ({
                    ...tab,
                    active: tab.id === EventProfileTabIdentifiers.OVERVIEW,
                }));
            }
            return updatedTabs;
        });
    };

    useEffect(() => {
        if (!event.loading) {
            if (!event.data || match.params.eventId !== event.data?.id.toString()) {
                loadEvent();
            } else if (event.data) {
                setInitState(event);
            } else {
                // event.loading false but no event.data and no load needed
            }
        }
    }, []);

    useEffect(() => {
        const currentRouteEventId = match.params.eventId;
        if (
            justPublished &&
            event?.data?.hasRecurringSeries &&
            event?.data?.id &&
            event.data.id.toString() === currentRouteEventId &&
            !hasStartedPollingRef.current
        ) {
            hasStartedPollingRef.current = true;
            pollingEventIdRef.current = event.data.id;
            dispatch(eventProfileActions.pollRecurringEventCreated(event.data.id));
        }
    }, [justPublished, event?.data?.id, event?.data?.hasRecurringSeries, match.params.eventId]);

    useEffect(() => {
        return () => {
            if (pollingEventIdRef.current) {
                dispatch(eventProfileActions.stopRecurringEventPolling(pollingEventIdRef.current));
            }
            hasStartedPollingRef.current = false;
            pollingEventIdRef.current = null;
        };
    }, []);

    useEffect(() => {
        if (event.data) {
            setInitState(event);
            const arePreRegActionsEnabled = event.data?.preRegAndEligibleListEnabled && isCurrentMemberAdmin;

            if (arePreRegActionsEnabled && eligiblePlayers.data === null && !eligiblePlayers.loading) {
                dispatch(eventProfileActions.getEligiblePlayers(event.data.id));
            }

            if (arePreRegActionsEnabled && preRegStats?.data === null && !preRegStats?.loading) {
                dispatch(eventProfileActions.getPreRegStats(event.data.id));
            }

            if (arePreRegActionsEnabled && preRegFilterOptions.data === null && !preRegFilterOptions.loading) {
                dispatch(eventProfileActions.getPreRegInviteFilters(event.data.id));
            }
        }
    }, [event.data, preRegFilterOptions.data, preRegStats?.data, eligiblePlayers.data]);

    useEffect(() => {
        if (event.error) {
            history.push(`/`);
        }
    }, [event.error]);

    useEffect(() => {
        setShowAddEditTeamPopUp(false);
    }, [teamStandings]);

    useEffect(() => {
        if (sidebarOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }, [sidebarOpen]);

    const navigateToFirstPublishedDraw = () => {
        const firstPublishedDraw = (draws.data?.find(draw => draw.published)) || null;
        if (!firstPublishedDraw) {
            return;
        }
        dispatch(eventProfileActions.getDraw({ eventId: event.data.id, drawId: firstPublishedDraw.id, setAsCurrentDraw: true }));
        history.replace({
            search: queryString.stringify({ ...queryParams, d: firstPublishedDraw.id }),
        });
    };

    const loadDrawFromUrlParam = (drawFromParam) => {
        if (!drawFromParam.parentDrawId) {
            dispatch(eventProfileActions.getDraw({ eventId: event.data.id, drawId: drawFromParam.id, setAsCurrentDraw: true }));
        } else {
            dispatch(eventProfileActions.getDraw({ eventId: event.data.id, drawId: drawFromParam.parentDrawId, dontAutoLoadFirstChildDraw: true }));
            dispatch(eventProfileActions.getDraw({ eventId: event.data.id, drawId: drawFromParam.id, isChildDraw: true }));
        }
    };

    useEffect(() => {
        if (!event.data || !draws.data?.length) {
            return;
        }

        const areDrawsLoading = currentDraw?.loading || parentDraw?.loading || false;
        if (areDrawsLoading) {
            return;
        }

        if (!queryParams.d) {
            if (currentDraw.data?.id) {
                history.replace({
                    search: queryString.stringify({ ...queryParams, d: currentDraw.data.id }),
                });
            } else {
                navigateToFirstPublishedDraw();
            }
            return;
        }

        const isDrawFromParamLoaded = String(currentDraw?.data?.id) === String(queryParams.d) || String(parentDraw?.data?.id) === String(queryParams.d);
        if (drawsDict[queryParams.d]?.published && !isDrawFromParamLoaded) {
            loadDrawFromUrlParam(drawsDict[queryParams.d]);
            return;
        }

        const currentDrawDiffersFromParam = currentDraw.data && String(currentDraw.data.id) !== String(queryParams.d);
        if (currentDrawDiffersFromParam) {
            history.replace({
                search: queryString.stringify({ ...queryParams, d: currentDraw.data.id }),
            });
            return;
        }

        // Fallback: URL ?d= param points to a draw that doesn't exist or isn't published.
        if (!drawsDict[queryParams.d]?.published && !currentDraw?.data) {
            navigateToFirstPublishedDraw();
        }
    }, [draws.data, queryParams.d, currentDraw, parentDraw, event.data]);

    // Keep selected tab in sync with URL query param `t` (when opening draws from schedule match card).
    useEffect(() => {
        if (!event.data) {
            return;
        }
        const tabIdentifier = parseInt(queryParams.t, 10) || EventProfileTabIdentifiers.OVERVIEW;
        setTabs((prevTabs) => {
            if (!prevTabs || prevTabs.length === 0) {
                return prevTabs;
            }
            const selectedTab = prevTabs.find(tab => tab.id === tabIdentifier);
            const safeTabId = selectedTab ? tabIdentifier : EventProfileTabIdentifiers.OVERVIEW;
            return prevTabs.map(tab => ({ ...tab, active: tab.id === safeTabId }));
        });
    }, [location.search, event.data]);

    useEffect(() => {
        if (queryParams.showPopup && !actionPerformed && event.data && auth.user) {
            handleShowLoginPopUp(queryParams.type);
            // remove query param
            updateQueryParam('showPopup', null);
            // eslint-disable-next-line react/no-did-update-set-state
            setActionPerformed(true);
            setInitState(event);
        }
    }, [queryParams.showPopup]);

    useEffect(() => {
        if (auth?.user?.id && brazeInstance) {
            logPowerCampaignEvent({
                search: props?.location?.search,
                eventName: eventNames.EVENT_PROFILE_PAGE,
                memberId: auth?.user?.id,
            });
        }
    }, [auth?.user?.id, brazeInstance]);

    const handleMultipleDivisionRegistrations = (divisionId, quantity, price, playerNames) => {
        setMultipleDivisionRegistrations(prev => ({
            ...prev,
            [divisionId]: {
                quantity,
                price,
                playerNames,
            },
        }));
    };

    const handleClearMultipleDivisionRegistrations = () => {
        setMultipleDivisionRegistrations({});
    };

    const onSendInviteToGroup = () => {
        if (inviteAllGroupMembers) {
            dispatch(eventProfileActions.sendInvitationToGroup(event.data.id, event.data.club?.id));
        }
        closePublishedPopup();
    };

    const onSendInviteToGroupValueChange = (value) => {
        setInviteAllGroupMembers(!value);
    };

    const handlePopupCancel = () => {
        setShowRegistrationPopup(false);
    };

    const updateQueryParam = (param, value) => {
        const parsed = queryString.parse(props.history.location.search);
        if (value) {
            parsed[param] = value;
        } else {
            delete parsed[param];
        }
        props.history.replace({
            search: queryString.stringify(parsed),
        });
    };

    const closePublishedPopup = () => {
        setShowPublishedPopup(false);
        dispatch(eventProfileActions.setJustPublishedFlag(false));
    };

    const closeShareUrlPopup = () => {
        setShowShareUrlPopup(false);
    };

    const exportRegistrants = () => {
        downloadLink.current.href = `/api/v1/tms/events/${event.data.id}/export`;
        downloadLink.current.download = `${event.data.name}.xlsx`;
        downloadLink.current.click();
    };

    const handleCropPhoto = async (values) => {
        await dispatch(eventProfileActions.cropEventBanner(event.data.id, values));
        dispatch(clearTempPhoto(true));
        setShowPhotoEditor(false);
    };

    const handleDeclineUpgradeToPowerClick = (e) => {
        if (e) {
            e.preventDefault();
        }
        handleRegClick(e, true);
    };

    /* Photo Upload */
    const handleHidePhotoEditor = () => {
        setShowPhotoEditor(false);
        dispatch(clearTempPhoto(true));
    };

    const handleRegPartnerAdded = () => {
        setRegPartnerAdded(true);
    };

    const handleOverlayClick = () => {
        if (sidebarOpen) {
            setSidebarOpen(false);
            setSidebarFlow('');
            if (regPartnerAdded) {
                loadEvent();
                if (event.data.eventStateId === eventStateTypeIds.PRE_REGISTRATION) {
                    window.location.reload();
                }
            }
        }
    };

    const handlePopupConfirmMissingInfo = () => {
        setShowRegistrationPopup(false);
        props.history.push('/events/account-info');
    };

    const handlePublishedShareClick = () => {
        closePublishedPopup();
        setShowShareUrlPopup(true);
    };

    const requireRatingSurvey = () => {
        const { claimedPlayer, pbrRangeRequiredEventRegistration } = auth.user || {};

        if (isTennisSportTypeEvent(event.data.sportTypeId)) {
            return claimedPlayer && utrRangeRequired && pbrRangeRequiredEventRegistration;
        }
        if (isPickleBallSportTypeEvent(event.data.sportTypeId)) {
            const isPickleballRated = getPickleBallRating(claimedPlayer, null).isRated;
            return claimedPlayer && !isPickleballRated;
        }

        return false;
    };

    const isRegistrationClosed = () => {
        const endUtc = event?.data?.eventSchedule?.registrationEndUtc;

        if (!endUtc) {
            return false;
        }

        const now = moment.utc();
        const end = moment.utc(endUtc);

        return now.isAfter(end);
    };

    const hasProviderInvite = () => {
        return pendingInvitationDivisions?.length > 0 || pendingAdminAddDivisions?.length > 0;
    };

    const startRegistrationFlow = (e, fromUpgradeStep, fromLoginPopUpCallBack = false, flow = '') => {
        if (isRegistrationClosed() && !hasProviderInvite()) {
            setShowRegClosedPopup(true);
            return;
        }

        const userAge = moment().diff(birthdate, 'years');

        if (isPaidHit && userAge < 18 && !(secondaryEmail && isSecondaryEmailVerified)) {
            setParentGuardianPopup(true);
        } else if (requireRatingSurvey()) {
            setShowRatingSurveyPopup(true);
        } else if (!fromLoginPopUpCallBack) {
            toRegistration(e, fromUpgradeStep, flow);
        } else {
            updateQueryParam('register', true);
        }

        trackEvent('Checkout Started', {
            userId: auth?.user?.id,
            eventId: event?.data?.id,
        });
    };

    const gateRegistrationForTennisAustraliaLink = async (proceed) => {
        let shouldGate = false;
        try {
            const axiosInstance = getApiAxiosInstance();
            const response = await getLinkedAccounts(axiosInstance);
            shouldGate = shouldGateAo1PointSlamRegistration({
                event: event?.data,
                isGateEnabled: isAo1PointSlamTaGateEnabled,
                hasLinkedTennisAustraliaAccount: hasTennisAustraliaLinkedAccount(response?.data),
            });
        } catch {
            shouldGate = false;
        }
        if (shouldGate) {
            setShowTennisAustraliaIdModal(true);
            return;
        }
        proceed();
    };

    const handleRegClick = (e, fromUpgradeStep, fromLoginPopUpCallBack = false, flow = '') => {
        const proceed = () => startRegistrationFlow(e, fromUpgradeStep, fromLoginPopUpCallBack, flow);
        if (requiresTennisAustraliaLinkCheck({
            event: event?.data,
            isGateEnabled: isAo1PointSlamTaGateEnabled,
            isAuthenticated: Boolean(auth?.user),
            flow,
        })) {
            gateRegistrationForTennisAustraliaLink(proceed);
            return;
        }
        proceed();
    };

    const handleTennisAustraliaLinkContinue = () => {
        const returnTo = encodeURIComponent(`${config.appHost}${location.pathname}`);
        setShowTennisAustraliaIdModal(false);
        sessionStorage.setItem(AO_1_POINT_SLAM_TA_LINK_PENDING_KEY, String(event?.data?.id ?? ''));
        window.location.href = `${config.apiHost}/v1/oauth/ta/initiate-link?platform=web&source=internal&flow=link&returnTo=${returnTo}`;
    };

    useEffect(() => {
        const clearLinkQueryParams = () => {
            updateQueryParam('error');
            updateQueryParam('error_description');
        };

        const hasVerifiedTennisAustraliaLink = async () => {
            try {
                const axiosInstance = getApiAxiosInstance();
                const response = await getLinkedAccounts(axiosInstance);
                return hasTennisAustraliaLinkedAccount(response?.data);
            } catch {
                return false;
            }
        };

        const handleTennisAustraliaReturn = () => {
            const pendingLink = sessionStorage.getItem(AO_1_POINT_SLAM_TA_LINK_PENDING_KEY);
            if (!pendingLink) {
                return;
            }
            sessionStorage.removeItem(AO_1_POINT_SLAM_TA_LINK_PENDING_KEY);

            const linkError = getTennisAustraliaLinkError({
                error: queryParams?.error,
                errorDescription: queryParams?.error_description,
            });

            if (linkError) {
                dispatch(showErrorPopup({
                    title: linkError.title,
                    message: linkError.message,
                    confirmButtonLabel: 'Try Again',
                    onConfirmClick: () => setShowTennisAustraliaIdModal(true),
                    showCancelButton: true,
                    cancelButtonLabel: 'Close',
                }));
                clearLinkQueryParams();
                return;
            }

            (async () => {
                const hasLinkedTennisAustraliaAccount = await hasVerifiedTennisAustraliaLink();

                // Coming back without a verified link means the user backed out, or the link
                // failed without telling us. We cannot distinguish the two, and they are not
                // registering right now, so say nothing rather than re-prompting — the gate
                // runs again on their next Register click and the server enforces it anyway.
                if (shouldShowTennisAustraliaLinkSuccessToast({
                    hasPendingLink: Boolean(pendingLink),
                    hasLinkError: Boolean(linkError),
                    hasLinkedTennisAustraliaAccount,
                })) {
                    dispatch(showSuccessToast(tennisAustraliaLinkSuccessToast));
                    setPendingRegistrationEventId(pendingLink);
                }

                clearLinkQueryParams();
            })();
        };

        handleTennisAustraliaReturn();

        // iOS Safari serves this page from the back/forward cache on a back-navigation out of
        // Tennis Australia, so the component never remounts and the call above never fires.
        const handlePageShow = (pageTransitionEvent) => {
            if (pageTransitionEvent.persisted) {
                handleTennisAustraliaReturn();
            }
        };

        window.addEventListener('pageshow', handlePageShow);
        return () => {
            window.removeEventListener('pageshow', handlePageShow);
        };
    }, []);

    useEffect(() => {
        if (!shouldResumeAo1PointSlamRegistration({
            pendingRegistrationEventId,
            eventId: event.data?.id,
            hasResumed: registrationResumedRef.current,
        })) {
            return;
        }
        registrationResumedRef.current = true;
        setPendingRegistrationEventId(null);
        try {
            startRegistrationFlow();
        } catch {
            // Leaving the flow part-way through would strand the page in a half-open state.
            setSidebarOpen(false);
            setSidebarFlow('');
        }
    }, [pendingRegistrationEventId, event.data]);

    useEffect(() => {
        if (queryParams?.register) {
            handleRegClick();
            updateQueryParam('register');
        }
    }, [queryParams.register]);

    const toRegistration = (e, fromUpgradeStep, flow) => {
        if (e) {
            e.stopPropagation();
        }
        const userParamsNeeded = [userParams.CLAIMED_PROFILE];

        if (isLoginPopUpNeeded(props.auth, userParamsNeeded)) {
            handleShowLoginPopUp('register', e, { fromUpgradeStep });
        } else {
            const { user } = props.auth;
            if (!user.birthdate || !user.location || !user.phone || !user.gender) {
                setShowRegistrationPopup(true);
                setRegistrationPopupMessage('We need some additional information before you can sign up for this event. Click below to continue.');
                setHandlePopupConfirm(handlePopupConfirmMissingInfo);
            } else {
                // Checking Event Regions with player Region
                // eslint-disable-next-line no-lonely-if
                if (regions.data?.length && !playerHasEventRegion(user, regions.data)) {
                    setShowEventRegionWarningPopup(true);
                } else {
                    setSidebarFlow(flow);
                    setSidebarOpen(fromUpgradeStep ? sidebarOpen : !sidebarOpen);
                }
            }
        }
    };

    const playerHasEventRegion = (user, regionList) => {
        if (!user.claimedPlayer?.playerProfileInformation?.regionId) {
            return false;
        }
        return regionList.findIndex(r => r.regionId === user.claimedPlayer.playerProfileInformation.regionId) > -1;
    };

    const handleShowLoginPopUp = (type, e, data) => {
        if (e) {
            e.stopPropagation();
        }
        let actionMethod;
        let onCloseCallback;
        const splitArray = type?.split('-') || [];
        switch (splitArray[0]) {
            case 'register': {
                const fromUpgradeStep = data?.fromUpgradeStep;
                if (fromUpgradeStep) {
                    actionMethod = () => handleRegClick(e, fromUpgradeStep);
                }
                break;
            }
            case 'tab': {
                const tabId = parseInt(splitArray[1]);
                actionMethod = () => handleTabClick({ tabId });
                onCloseCallback = () => {
                    const currentTabId = parseInt(queryParams.t) || EventProfileTabIdentifiers.OVERVIEW;
                    const currentTab = tabs.find(tab => tab.id === currentTabId);
                    if (!auth.user && currentTab?.needsLogin) {
                        handleTabClick({ tabId: EventProfileTabIdentifiers.OVERVIEW });
                    }
                };
                break;
            }
            default:
                break;
        }
        const userParamsNeeded = [
            userParams.CLAIMED_PROFILE,
        ];
        if (isLoginPopUpNeeded(auth, userParamsNeeded)) {
            const popupData = {
                userParamsNeeded,
                titles: titles.EVENT_REGISTER,
                performAction: actionMethod,
                onCloseClick: onCloseCallback,
                type, // should be sent back as query while redirecting from facebook to perform proper action
            };
            dispatch(loginPopUpActions.showLoginPopUp(popupData));
        } else if (actionMethod) {
            actionMethod();
        } else {
            // no login popup and no action to perform
        }
    };
    const playersTabStates = {
        REGISTERED: 'registered',
        WITHDRAWN: 'withdrawn',
        ERRORS: 'errors',
    };

    const onSelectPlayerDivision = (selected) => {
        const eventDivision = event.data.eventDivisions.find(div => div.id === selected.value);
        if (selected.value === playersTabStates.ERRORS) {
            playersTabState.divisionId = selected.value;
            playersTabState.divisionName = selected.divisionName;
            playersTabState.divisionFormatTypeId = selected.divisionFormatTypeId;
            playersTabState.teamPaymentTypeId = selected.teamPaymentTypeId;
            playersTabState.registeredCount = event.data?.membersWithoutProfile?.length || 0;
            playersTabState.selectedStatus = {
                value: playersTabStates.REGISTERED,
                label: 'Registered',
            };
            playersTabState.specificDivisionDateEnabled = selected.specificDivisionDateEnabled;
            playersTabState.specificDivisionDateUtc = selected.specificDivisionDateUtc;
        } else {
            playersTabState.divisionId = selected.value;
            playersTabState.divisionName = selected.divisionName;
            playersTabState.divisionFormatTypeId = selected.divisionFormatTypeId;
            playersTabState.teamPaymentTypeId = selected.teamPaymentTypeId;
            playersTabState.registeredCount = eventDivision?.registeredCount;
            playersTabState.selectedStatus = {
                value: playersTabStates.REGISTERED,
                label: 'Registered',
            };
            playersTabState.specificDivisionDateEnabled = selected.specificDivisionDateEnabled;
            playersTabState.specificDivisionDateUtc = selected.specificDivisionDateUtc;
        }
        if (eventDivision.allowWaitlist) {
            playersTabState.sortParam = sortParamTypes.REGDATE;
            playersTabState.sortType = SortType.ASC;
        } else {
            playersTabState.sortParam = event.data.sportTypeId === sportTypeIds.PICKLEBALL ? getDefaultSortParamForPickleballDivision(eventDivision) : getDefaultSortParamForDivision(eventDivision);
            playersTabState.sortType = getDefaultSortOrderForDivision(eventDivision);
        }
        dispatch(eventProfileActions.setPlayersTabState(playersTabState));
    };

    const handleTabClick = ({ tabId, divisionId, drawId }) => {
        updateQueryParam('t', tabId);
        const tabToBeSelected = tabs.find(tab => tab.id === tabId);
        if (tabToBeSelected?.needsLogin && !auth.user) {
            handleShowLoginPopUp(`tab-${tabId}`);
            return;
        }

        if (drawId) {
            updateQueryParam('d', drawId);
        }
        if (divisionId) {
            updateQueryParam('divisionId', divisionId);
        }

        if (divisionId) {
            const selectedDivision = event.data.eventDivisions.find(div => div.id === divisionId);
            onSelectPlayerDivision({ value: divisionId, divisionName: selectedDivision.name, ...selectedDivision });
        }

        // Use functional update to get the latest tabs state (HUB-644)
        setTabs((prevTabs) => prevTabs.map((_tab) => ({ ..._tab, active: tabId === _tab.id })));
    };

    const handleUploadPhoto = (file) => {
        dispatch(uploadTempPhoto(file));
    };

    const handleUploadPhotoStart = () => {
        setShowPhotoEditor(true);
    };

    const sendEventInvite = () => {
        dispatch(eventProfileActions.sendEventInviteToMembers());
    };

    const sendMessage = async (recipient, recipientContextType = MemberContextTypes.PLAYER) => {
        if (recipient?.memberId && event.data) {
            const conversation = {
                entities: [],
            };
            conversation.originatingContext = coreUI.types.messagingConversationContextType.find(type => type.id === ConversationContextTypes.EVENT_PROFILE)?.value;
            conversation.originatingContextId = event.data.id;

            // Add sender entities
            let senderContexttype;
            if (isEventDirector(event.data, auth.user.id)) {
                senderContexttype = MemberContextTypes.EVENT_ORGANIZER;
            } else if (event.data.currentMember?.registeredDivisions?.length > 0) {
                senderContexttype = MemberContextTypes.EVENT_PARTCIPANT;
            } else {
                senderContexttype = MemberContextTypes.PLAYER;
            }
            conversation.entities.push(getMemberEntityObject(coreUI.types, auth.user.id, senderContexttype));

            // Add reciepient entities
            const reciepientContexttype = isEventDirector(event.data, recipient.memberId)
                ? MemberContextTypes.EVENT_ORGANIZER
                : recipientContextType;
            conversation.entities.push(getMemberEntityObject(coreUI.types, recipient.memberId, reciepientContexttype));

            dispatch(messagingActions.setNewConv(true));
            dispatch(messagingActions.addRecepient({ member: recipient }));
            props.history.push(`/inbox`);
        }
    };

    const handleShowShareUrlPopup = () => {
        setShowShareUrlPopup(true);
        setIsDraft(!event.data.published);
    };

    const submitShareUrlPopup = () => {
        setShowShareUrlPopup(false);
        setShowShareUrlConfirmPopup(true);
    };

    const toRegConfirmation = (res) => {
        const updatedTabs = tabs.map((tab) => ({ ...tab, active: false }));
        setTabs(updatedTabs);
        setCollapsed(true);
        setSidebarOpen(false);
        setSidebarFlow();
        if (res) {
            dispatch(eventProfileActions.setRegConfirmation(res));
            dispatch(eventProfileActions.getEvent(match.params.eventId));
            dispatch(eventProfileActions.getCurrentMemberRegistration(match.params.eventId));
        }
    };

    const toMultiRegConfirmation = () => {
        const updatedTabs = tabs.map((tab) => ({ ...tab, active: false }));
        setTabs(updatedTabs);
        setCollapsed(true);
        setSidebarOpen(false);
        setSidebarFlow();
        setSuccesfulMultiDivisionRegistration(true);
    };

    const backToEvent = () => {
        dispatch(eventProfileActions.setRegConfirmation(null));
        setTabs(tabs.map((tab) => ({ ...tab, active: tab.id === EventProfileTabIdentifiers.OVERVIEW })));
        setCollapsed(false);
        handleClearMultipleDivisionRegistrations();
    };

    const toggleMessagePopUp = (memberIds) => {
        setShowMessagePopUp(memberIds || false);
        if (!memberIds) {
            dispatch(eventProfileActions.resetPlayerMessageState());
        }
    };

    const togglePlayerRegisterPopUp = () => {
        setShowRegisterPlayerPopUp(!showRegisterPlayerPopUp);
    };

    const toggleUploadAttachmentPopUp = () => {
        setShowUploadAttachmentPopUp(!showUploadAttachmentPopUp);
    };

    const toggleAddWeatherUpdatePopup = () => {
        setShowAddWeatherUpdatePopUp(!showAddWeatherUpdatePopUp);
    };

    const toggleAddEligiblePlayersSidebar = () => {
        setShowAddEligiblePlayersSidebar(!showAddEligiblePlayersSidebar);
    };

    const toggleInvitePreRegistrantsSidebar = () => {
        setShowInvitePreRegistrantsSidebar(!showInvitePreRegistrantsSidebar);
    };

    const onAddEligiblePlayersSubmitSuccess = async (data) => {
        setAddEligiblePlayersErrors(data);
        if (data.alreadyAddedPlayers.length > 0 || data.invalidPlayerIds.length > 0 || data.unclaimedPlayers.length > 0) {
            setShowAddEligiblePlayersError(true);
            return;
        }
        if (tabs.find((tab) => tab.id === EventProfileTabIdentifiers.ELIGIBLE_PLAYERS).showTab === false) {
            dispatch(eventProfileActions.getEvent(match.params.eventId));
        } else {
            handleTabClick({ tabId: EventProfileTabIdentifiers.ELIGIBLE_PLAYERS });
            dispatch(eventProfileActions.getEligiblePlayers(event.data.id));
        }
    };

    const onSendPreRegistrantInvitationsSuccess = async (data) => {
        setPreRegistrantInviteErrors(data);
        if (data.invalidPlayerIds.length > 0 || data.unclaimedPlayers.length > 0 || data.invalidPlayersForDivisionCategoryGender.length > 0) {
            setShowSendPreRegistrantInviteError(true);
            return;
        }
        dispatch(eventProfileActions.getPreRegStats(match.params.eventId));
        if (tabs.find((tab) => tab.id === EventProfileTabIdentifiers.PRE_REG_INVITES).showTab === false) {
            dispatch(eventProfileActions.getEvent(match.params.eventId));
        } else {
            handleTabClick({ tabId: EventProfileTabIdentifiers.PRE_REG_INVITES });
            if (preRegInvitesTabRef?.current) {
                preRegInvitesTabRef.current.refreshInviteList();
            }
        }
    };

    const handleCloseAddEligiblePlayerError = async () => {
        setShowAddEligiblePlayersError(false);
        if (tabs.find((tab) => tab.id === EventProfileTabIdentifiers.ELIGIBLE_PLAYERS).showTab === false) {
            dispatch(eventProfileActions.getEvent(match.params.eventId));
        } else {
            await dispatch(eventProfileActions.getEligiblePlayers(event.data.id));
        }
    };

    const handleClosePreRegistrantInviteError = async () => {
        setShowSendPreRegistrantInviteError(false);
        if (tabs.find((tab) => tab.id === EventProfileTabIdentifiers.ELIGIBLE_PLAYERS).showTab === false) {
            dispatch(eventProfileActions.getEvent(match.params.eventId));
        } else if (preRegInvitesTabRef?.current) {
            preRegInvitesTabRef.current.refreshInviteList();
        } else {
            // no invite list to refresh
        }
    };

    const componentConfigActionPerformed = (configType, actionName, eventId) => {
        const params = {
            eventId,
        };
        dispatch(postComponentActionPerformd('event-profile', configType, actionName, { properties: params }));
    };

    const handleUploadAttachment = async (formData) => {
        await dispatch(eventProfileActions.uploadEventAttachment({ eventId: event.data.id, formData }));
    };

    const addTeamStanding = (eventId, newTeamStanding) => {
        dispatch(eventProfileActions.addTeamStanding(eventId, newTeamStanding));
    };
    const editTeamStanding = (eventId, teamStanding) => {
        dispatch(eventProfileActions.editTeamStanding(eventId, teamStanding));
    };
    const deleteTeamStanding = (eventId, standingId) => {
        dispatch(eventProfileActions.deleteTeamStanding(eventId, standingId));
    };

    const handleEventRegionWarningOnClose = () => {
        setShowEventRegionWarningPopup(false);
    };

    const handleEventRegionPlayerProfileRedirect = () => {
        const playerId = auth.user.claimedPlayer?.playerId;
        props.history.push(`/profiles/${playerId}`);
    };

    const linkCopied = () => {
        if (window?.analytics) {
            const path = '/share/event';
            const properties = {
                path,
                url: path,
                name: event.data.name,
            };
            window.analytics.page('share event profile', 'share link', properties);
        }
    };

    const redirectToRatingSurveyPage = () => {
        dispatch(setDisableRangeSurveySkip(true));
        dispatch(setSkipOnboardingIntroPopup(true));
        if (isPickleBallSportTypeEvent(event.data.sportTypeId)) {
            props.history.push(`/pickleball-survey?return=/events/${event.data.id}`);
        } else {
            props.history.push(`/onboarding-survey?return=/events/${event.data.id}`);
        }
    };

    const handleShowAddEditTeamPopup = (action, standing) => {
        setShowAddEditTeamPopUp(action);
        setSelectedTeamStanding(standing);
    };

    const isFullWidthTab = () => {
        const fullWidthTabs = [
            {
                tabId: EventProfileTabIdentifiers.PLAYERS,
                useFullWidth: true,
            },
            {
                tabId: EventProfileTabIdentifiers.LIVE,
                useFullWidth: true,
            },
            {
                tabId: EventProfileTabIdentifiers.SCHEDULE,
                useFullWidth: event?.data?.scheduleTypeId === drawScheduleTypeIds.NEXT_AVAILABLE,
            },
        ];

        const activeFullWidthTab = fullWidthTabs.find(tab => tab.tabId === activeTab?.id && tab.useFullWidth);

        return (!regConfirmation && activeFullWidthTab);
    };

    const onEditWeatherNotification = (notification) => {
        setNotificationToEdit(notification);
        toggleAddWeatherUpdatePopup();
    };

    const onCloseWeatherPopup = () => {
        setNotificationToEdit(null);
        toggleAddWeatherUpdatePopup();
    };

    const onDivisionSelect = (divisionId) => {
        handleTabClick({ tabId: 2, divisionId });
    };

    const eventProfileMetaData = head({
        ...generateEventMetaData(event?.data, config),
        jsonLd: generateEventJsonLd(event?.data, config),
    });

    const handleFindPlayerClick = (val) => {
        setFocusFindPlayer(val);
        setTimeout(() => setFocusFindPlayer(false), 1000);
    };

    // RENDER --------------------------------------------------------------------------------

    if (event.data) {
        return (
            <div data-testid={dataTestId}>
                {eventProfileMetaData}
                {(event.data && !event.loading) && (
                    <>
                        <a ref={downloadLink} className="d-none" target="_blank" data-testid="event-profile-v3.download-link" />
                        <div
                            id="sidebar"
                            className={sidebarOpen ? 'open' : 'closed'}
                        >
                            {sidebarContentMounted && (
                                <SideBarV3
                                    auth={auth}
                                    event={event.data}
                                    sidebarOpen={sidebarOpen}
                                    sidebarFlow={sidebarFlow}
                                    handleOverlayClick={handleOverlayClick}
                                    handleDeclineUpgradeToPowerClick={handleDeclineUpgradeToPowerClick}
                                    handleRegPartnerAdded={handleRegPartnerAdded}
                                    toRegConfirmation={toRegConfirmation}
                                    toMultiRegConfirmation={toMultiRegConfirmation}
                                    clubVerificationFee={clubVerificationFee}
                                    location={location}
                                    clubId={clubId}
                                    setSidebarFlow={setSidebarFlow}
                                    multipleDivisionRegistrations={multipleDivisionRegistrations}
                                    handleMultipleDivisionRegistrations={handleMultipleDivisionRegistrations}
                                    setSuccesfulMultiDivisionRegistration={setSuccesfulMultiDivisionRegistration}
                                    handleClearMultipleDivisionRegistrations={handleClearMultipleDivisionRegistrations}
                                />
                            )}
                        </div>
                        <div
                            id="sidebar-overlay"
                            className={sidebarOpen ? 'open' : 'closed'}
                            onClick={handleOverlayClick}
                        />
                        {event.data?.isDemoEvent && (
                            <div className={`${styles.section} sub-header admin-splash bg-teal`}>
                                <div className={`container bg-transparent`}>
                                    <div className="row">
                                        <div className={`col d-flex align-items-center justify-content-center`}>
                                            <h6 data-testid={dataTestId ? `${dataTestId}.demo-event-banner` : undefined}>This a demo event. You can try registering yourself, adding demo players, creating draws and posting results. Demo event will be reset within a few weeks.</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {isCurrentMemberAdmin && (
                            <AdminBarV3
                                isCurrentMemberAdmin={isCurrentMemberAdmin}
                                location={location}
                                toggleUploadAttachmentPopUp={toggleUploadAttachmentPopUp}
                                togglePlayerRegisterPopUp={togglePlayerRegisterPopUp}
                                exportRegistrants={exportRegistrants}
                                toggleMessagePopUp={toggleMessagePopUp}
                                toggleAddWeatherUpdatePopup={toggleAddWeatherUpdatePopup}
                                toggleAddEligiblePlayersSidebar={toggleAddEligiblePlayersSidebar}
                                toggleInvitePreRegistrantsSidebar={toggleInvitePreRegistrantsSidebar}
                            />
                        )}
                        {isCurrentMemberVolunteer && !isCurrentMemberAdmin && (
                            <AdminBarV3
                                isCurrentMemberVolunteer={isCurrentMemberVolunteer}
                                isCurrentMemberAdmin={isCurrentMemberAdmin}
                                location={location}
                                toggleUploadAttachmentPopUp={toggleUploadAttachmentPopUp}
                                togglePlayerRegisterPopUp={togglePlayerRegisterPopUp}
                                exportRegistrants={exportRegistrants}
                                toggleMessagePopUp={toggleMessagePopUp}
                                toggleAddWeatherUpdatePopup={toggleAddWeatherUpdatePopup}
                                toggleAddEligiblePlayersSidebar={toggleAddEligiblePlayersSidebar}
                                toggleInvitePreRegistrantsSidebar={toggleInvitePreRegistrantsSidebar}
                            />
                        )}
                        <EventProfileHeaderV3
                            isCurrentMemberAdmin={isCurrentMemberAdmin}
                            collapsed={collapsed}
                            tabs={tabs}
                            handleRegClick={handleRegClick}
                            handleTabClick={handleTabClick}
                            showShareUrlPopup={handleShowShareUrlPopup}
                            sportTypeId={event.data.sportTypeId}
                            isRegistrationIncomplete={!!pendingInvitationDivisions.length}
                            hasPendingAdminInvitation={!!pendingAdminAddDivisions.length}
                            handleFindPlayerClick={handleFindPlayerClick}
                            isPttEvent={isPttEvent}
                            players={players.data}
                            isCurrentMemberClubOrganizer={isCurrentMemberClubOrganizer}
                        />
                        <div className={`${styles.section} ${styles.eventProfileV3} bg-transparent main-content`}>
                            <div className={`container${isFullWidthTab() ? '-fluid' : ''} bg-transparent`}>
                                <div className="row">
                                    <div className="col">
                                        {!regConfirmation && (
                                            <>
                                                {activeTab?.id === EventProfileTabIdentifiers.OVERVIEW && (
                                                    <OverviewTabContent
                                                        clubVerificationFee={clubVerificationFee}
                                                        isCurrentMemberAdmin={isCurrentMemberAdmin}
                                                        sendMessage={(recipient) => sendMessage(recipient, MemberContextTypes.EVENT_ORGANIZER)}
                                                        bannerImage={bannerImage}
                                                        collapsed={collapsed}
                                                        handleUploadPhoto={handleUploadPhoto}
                                                        handleUploadPhotoStart={handleUploadPhotoStart}
                                                        onEditWeatherNotification={onEditWeatherNotification}
                                                    />
                                                )}
                                                {activeTab?.id === EventProfileTabIdentifiers.DIVISIONS && (
                                                    <DivisionsTabContentV4
                                                        clubVerificationFee={clubVerificationFee}
                                                        isCurrentMemberAdmin={isCurrentMemberAdmin}
                                                        handleRegClick={handleRegClick}
                                                        onDivisionSelect={onDivisionSelect}
                                                    />
                                                )}
                                                {activeTab?.id === EventProfileTabIdentifiers.PLAYERS && (
                                                    <ProtectedTabContent tab={activeTab} auth={auth}>
                                                        <PlayersTabContentV3
                                                            isCurrentMemberAdmin={isCurrentMemberAdmin}
                                                            sendMessage={(recipient) => sendMessage(recipient, MemberContextTypes.EVENT_PARTCIPANT)}
                                                            sportTypeId={event.data.sportTypeId}
                                                            hideUtrLabel={true}
                                                            toggleMessagePopUp={toggleMessagePopUp}
                                                            handleTabClick={handleTabClick}
                                                            updateQueryParam={updateQueryParam}
                                                            focusFindPlayer={focusFindPlayer}
                                                        />
                                                    </ProtectedTabContent>
                                                )}
                                                {isTeamLeague && activeTab?.id === EventProfileTabIdentifiers.TEAM_STANDINGS && (
                                                    <ProtectedTabContent tab={activeTab} auth={auth}>
                                                        <TeamStandingsContentV2
                                                            isCurrentMemberAdmin={isCurrentMemberAdmin}
                                                            showAddEditTeamPopUp={handleShowAddEditTeamPopup}
                                                            deleteTeamStanding={deleteTeamStanding}
                                                            eventId={event.data?.id}
                                                        />
                                                    </ProtectedTabContent>
                                                )}
                                                {activeTab?.id === EventProfileTabIdentifiers.DRAWS && (
                                                    <ProtectedTabContent tab={activeTab} auth={auth}>
                                                        <DrawsTabContentV3
                                                            isCurrentMemberAdmin={isCurrentMemberAdmin}
                                                            collapsed={collapsed}
                                                            sportTypeId={event.data.sportTypeId}
                                                        />
                                                    </ProtectedTabContent>
                                                )}
                                                {!isTeamLeague && activeTab?.id === EventProfileTabIdentifiers.SCHEDULE && (
                                                    <ProtectedTabContent tab={activeTab} auth={auth}>
                                                        <ScheduleTabContentV2
                                                            scheduleTypeId={event.data?.scheduleTypeId}
                                                            isCurrentMemberAdmin={isCurrentMemberAdmin}
                                                            eventId={event?.data?.id}
                                                        />
                                                    </ProtectedTabContent>
                                                )}
                                                {activeTab?.id === EventProfileTabIdentifiers.ELIGIBLE_PLAYERS && (
                                                    <ProtectedTabContent tab={activeTab} auth={auth}>
                                                        <EligiblePlayersTabContent
                                                            eligiblePlayers={eligiblePlayers}
                                                            isPickleballEvent={isPickleBallSportTypeEvent(event?.data?.sportTypeId)}
                                                            eventId={event?.data?.id}
                                                            utrTypeId={event?.data?.utrTypeId}
                                                            sportTypeId={event?.data?.sportTypeId}
                                                            isCurrentMemberAdmin={isCurrentMemberAdmin}
                                                        />
                                                    </ProtectedTabContent>
                                                )}
                                                {activeTab?.id === EventProfileTabIdentifiers.PRE_REG_INVITES && (
                                                    <ProtectedTabContent tab={activeTab} auth={auth}>
                                                        <PreRegInvitesTabContent
                                                            ref={preRegInvitesTabRef}
                                                            preRegInvites={preRegInvites}
                                                            isPickleballEvent={isPickleBallSportTypeEvent(event?.data?.sportTypeId)}
                                                            eventId={event?.data?.id}
                                                            preRegFilterOptions={preRegFilterOptions?.data}
                                                            utrTypeId={event?.data?.utrTypeId}
                                                            sportTypeId={event?.data?.sportTypeId}
                                                            isCurrentMemberAdmin={isCurrentMemberAdmin}
                                                            toggleMessagePopUp={toggleMessagePopUp}
                                                        />
                                                    </ProtectedTabContent>
                                                )}
                                                {activeTab?.id === EventProfileTabIdentifiers.LIVE && (
                                                    <ProtectedTabContent tab={activeTab} auth={auth}>
                                                        <NextAvailableLiveMatchesTabContent
                                                            handleTabClick={handleTabClick}
                                                        />
                                                    </ProtectedTabContent>
                                                )}
                                            </>
                                        )}
                                        {collapsed && regConfirmation && (
                                            <RegConfirmationV3
                                                eventId={event.data?.id}
                                                loggedInUserId={auth?.user?.id}
                                                backToEvent={backToEvent}
                                                isWebView={isWebView}
                                                onShowShareUrlPopup={handleShowShareUrlPopup}
                                            />
                                        )}
                                        {collapsed && succesfulMultiDivisionRegistration && (
                                            <MultiRegConfirmation
                                                eventId={event.data?.id}
                                                loggedInUserId={auth?.user?.id}
                                                backToEvent={backToEvent}
                                                isWebView={isWebView}
                                                onShowShareUrlPopup={handleShowShareUrlPopup}
                                                multipleDivisionRegistrations={multipleDivisionRegistrations}
                                                sidebarFlow={sidebarFlow}
                                                succesfulMultiDivisionRegistration={succesfulMultiDivisionRegistration}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {showRegistrationPopup ? (
                            <Popup
                                closePopup={handlePopupCancel}
                                confirmPopup={handlePopupConfirm}
                                message={registrationPopupMessage}
                            />
                        ) : null}

                        {showEventRegionWarningPopup && (
                            <EventRegionWarningPopup
                                regions={regions.data}
                                onCloseClick={handleEventRegionWarningOnClose}
                                onContinueClick={handleEventRegionPlayerProfileRedirect}
                            />
                        )}

                        {showMessagePopUp && (
                            <MessagePopUp
                                onCloseClick={() => toggleMessagePopUp()}
                                title={`Message ${showMessagePopUp?.length ? 'selected' : 'all'} players`}
                                subTitle={`Send an email update to ${showMessagePopUp?.length ? 'the selected' : 'all'}  players.`}
                                placeHolder={`Type message to include in email to ${showMessagePopUp?.length ? 'the selected' : 'all'}  players.`}
                                sendText="Send Message"
                                onSendClick={({ values }) => {
                                    dispatch(eventProfileActions.sendMessageToPlayers(values.notes.replace(/(?:\r\n|\r|\n)/g, '<br>'), event.data.id, undefined, values.organizerCopy, showMessagePopUp?.length ? showMessagePopUp : null));
                                }}
                                isSending={playerMessageEmail?.loading}
                                isSuccess={playerMessageEmail?.success}
                                isError={playerMessageEmail?.error}
                                errorMessage={playerMessageEmail?.errorMessage}
                                successMessage={'Emails have been sent successfully.'}
                            />
                        )}
                        {showRegisterPlayerPopUp && (
                            <RegisterPlayerToEventPopUpV2
                                onCloseClick={() => {
                                    togglePlayerRegisterPopUp();
                                }}
                                onPlayerAdded={(addedDivisionId) => {
                                    togglePlayerRegisterPopUp();
                                    dispatch(eventProfileActions.refreshEventParticipantData(event.data.id, {
                                        divisionIds: addedDivisionId ? [addedDivisionId] : [],
                                    }));
                                    handleTabClick({ tabId: EventProfileTabIdentifiers.PLAYERS });
                                }}
                                divisions={(event.data?.eventDivisions) || []}
                                eventId={event.data?.id}
                                isDemoEvent={event.data?.isDemoEvent}
                                sportTypeId={event.data?.sportTypeId}
                            />
                        )}
                    </>
                )}
                {(isCurrentMemberAdmin) && (
                    <PhotoEditor
                        showEditor={showPhotoEditor}
                        closeEditor={handleHidePhotoEditor}
                        imageUrl={uploads.tempPhotoUrl}
                        uploadCropData={handleCropPhoto}
                        type={'event_banner'}
                        data-testid="modal.event-profile.photo-editor"
                    />
                )}
                <ClubInactivePopup
                    show={showInactiveClubPopup}
                    close={() => setShowInactiveClubPopup(false)}
                    status={clubStatus ? clubStatus.value : null}
                    clubTierType={clubTierType}
                />

                {showPublishedPopup && auth.user && event.data && (
                    <PublishedPopup
                        firstName={auth.user.firstName}
                        clubName={event.data.club.name}
                        eventName={event.data.name}
                        eventDescription={event.data.eventLocations[0].googleFormattedName}
                        eventStartMonth={event.data.eventSchedule.eventStartMonth}
                        eventStartDate={event.data.eventSchedule.eventStartDate}
                        verifiedEvent={event.data.utrTypeId === utrTypeIds.SANCTIONED}
                        onCloseClick={closePublishedPopup}
                        onShareClick={handlePublishedShareClick}
                        inviteAllGroupMembers={inviteAllGroupMembers}
                        onSendInviteToGroupValueChange={onSendInviteToGroupValueChange}
                        onSendInviteToGroup={onSendInviteToGroup}
                        usapVerificationTypeId={event?.data?.usapVerificationTypeId}
                        hasRecurringSeries={event?.data?.hasRecurringSeries}
                    />
                )}
                {showShareUrlPopup && (
                    <ShareUrlPopupNew
                        title={'Spread the word'}
                        subtitle={'Copy & share the link w/anyone'}
                        text={'Copy Event Invite Link...'}
                        url={`${eventInviteUrl}`}
                        hideButton={!isCurrentMemberAdmin}
                        isDraft={isDraft}
                        closeBtnTxt={`Invite Club Members`}
                        onCloseClick={closeShareUrlPopup}
                        onSubmit={submitShareUrlPopup}
                        linkCopied={linkCopied}
                    />
                )}

                {showShareUrlConfirmPopup && (
                    <AwaitApiSuccessPopup
                        confirmationTitle={`Confirm`}
                        confirmationMessage={`Email your club members to let them know about this event.`}
                        onCloseClick={() => {
                            setShowShareUrlConfirmPopup(false);
                        }}
                        onCtaClick={sendEventInvite}
                        successMessage={'Emails have been sent successfully.'}
                        isSending={eventInviteEmail?.loading}
                        isSuccess={eventInviteEmail?.success}
                        isError={eventInviteEmail?.error}
                    />
                )}

                {event.data?.isDemoEvent && demoEventIntroPopUp && showDemoEventIntroPopUp && (
                    <WelcomePopUp
                        dangerouslySetInnerHTML={true}
                        welcomeTitles={{
                            title: 'Welcome to your demo event!',
                            subTitle: 'Try creating and running an event in a test environment',
                            description: 'You can set up and configure any type of event (other than paid events), add sample players, create draws and post scores. You can reset and recreate this demo event as many times as you want.',
                        }}
                        onCloseClick={() => {
                            setShowDemoEventIntroPopUp(false);
                            componentConfigActionPerformed(demoEventIntroPopUp.type, demoEventIntroPopUp.actions.dismissed.event, event.data.id);
                        }}
                        onCtaClick={() => {
                            setShowDemoEventIntroPopUp(false);
                            componentConfigActionPerformed(demoEventIntroPopUp.type, demoEventIntroPopUp.actions.dismissed.event, event.data.id);
                        }}
                    />
                )}

                {showUploadAttachmentPopUp && (
                    <AttachmentUploadPopup
                        onCloseClick={async () => {
                            setShowUploadAttachmentPopUp(false);
                        }}
                        onCtaClick={handleUploadAttachment}
                    />
                )}

                {showAddWeatherUpdatePopUp && (
                    <AddWeatherUpdatePopup
                        event={event.data}
                        onCloseClick={onCloseWeatherPopup}
                        weatherNotification={notificationToEdit}
                    />
                )}

                {showAddEditTeamPopUp !== false && (
                    <AddEditTeamStandingPopUp
                        onCloseClick={() => setShowAddEditTeamPopUp(false)}
                        teamPopUpAction={showAddEditTeamPopUp}
                        addTeamStanding={addTeamStanding}
                        eventId={event.data?.id}
                        selectedTeamStanding={selectedTeamStanding}
                        editTeamStanding={editTeamStanding}
                    />
                )}
                {parentGuardianPopup && (
                    <ConfirmActionPopup1Btn
                        onCloseClick={() => setParentGuardianPopup(false)}
                        onCtaClick={() => props.history.push('/settings/account')}
                        confirmationTitle={`Add Parent/Guardian email address`}
                        confirmationMessage={`To register for a paid hit, please add an email address of your parent or guardian. Once it is verified you can register for the event. You can add this email from your user settings, in the 'Parent/Guardian Email' field.`}
                        confirmButtonLabel={`Add Parent or Guardian Email`}
                    />
                )}
                {showRatingSurveyPopup && (
                    <ConfirmActionPopup1Btn
                        onCloseClick={() => setShowRatingSurveyPopup(false)}
                        onCtaClick={redirectToRatingSurveyPage}
                        confirmationTitle={`Get your ${isPickleBallSportTypeEvent(event.data.sportTypeId) ? ratingTypes.pickleball : ratingTypes.tennis} Rating started`}
                        confirmationMessage={`We need a little information to get your ${isPickleBallSportTypeEvent(event.data.sportTypeId) ? ratingTypes.pickleball : ratingTypes.tennis} Rating estimated. It's the first step to enjoying more level-based play. Your coach or club needs this to match you up for this event (required)`}
                        confirmButtonLabel={`Next`}
                    />
                )}
                {!currentMemberRegistration.loading && !event.loading && (
                    <PlayerPendingInvitations
                        event={event.data}
                        currentMemberRegistration={currentMemberRegistration.data}
                        clubVerificationFee={clubVerificationFee}
                        gotoRegistration={toRegistration}
                        hideInvitations={splash.show || collapsed || regConfirmation}
                    />
                )}
                {showAddEligiblePlayersSidebar && (
                    <SidebarAddEligiblePlayers eventId={event.data?.id} onClose={toggleAddEligiblePlayersSidebar} onSubmitSuccess={onAddEligiblePlayersSubmitSuccess} />
                )}
                {showAddEligiblePlayersError && (
                    <GenericPopUp
                        className={`popup-md`}
                        onCloseClick={handleCloseAddEligiblePlayerError}
                    >
                        <div className="text-error h5 pt16" data-testid="event-profile-v3.eligible-players-error.title">Error</div>
                        {addEligiblePlayersErrors?.alreadyAddedPlayers?.length > 0 && (
                            <div data-testid="event-profile-v3.eligible-players-error.already-added-section">
                                <div className="section-subtext text-left mt24 mb8" data-testid="event-profile-v3.eligible-players-error.already-added-label">Already added</div>
                                <div>
                                    {addEligiblePlayersErrors?.alreadyAddedPlayers.map((player) => (
                                        <a href={`/profiles/${player.playerId}`} className="dib mr8" key={`errored-players-${player.playerId}`} data-testid={`event-profile-v3.eligible-players-error.already-added-player-${player.playerId}`}>
                                            {player.playerId},
                                        </a>
                                    ))}
                                </div>
                            </div>
                        )}
                        {addEligiblePlayersErrors?.unclaimedPlayers?.length > 0 && (
                            <div data-testid="event-profile-v3.eligible-players-error.unclaimed-section">
                                <div className="section-subtext text-left mt24 mb8" data-testid="event-profile-v3.eligible-players-error.unclaimed-label">Not claimed</div>
                                <div>
                                    {addEligiblePlayersErrors.unclaimedPlayers.map((player) => (
                                        <a href={`/profiles/${player.playerId}`} className="dib mr8" key={`errored-players-${player.playerId}`} data-testid={`event-profile-v3.eligible-players-error.unclaimed-player-${player.playerId}`}>
                                            {player.playerId},
                                        </a>
                                    ))}
                                </div>
                            </div>
                        )}
                        {addEligiblePlayersErrors?.invalidPlayerIds?.length > 0 && (
                            <div data-testid="event-profile-v3.eligible-players-error.invalid-section">
                                <div className="section-subtext text-left mt24 mb8" data-testid="event-profile-v3.eligible-players-error.invalid-label">Not valid</div>
                                <div>
                                    {addEligiblePlayersErrors.invalidPlayerIds.map((playerId) => (
                                        <div className="dib mr8" key={`errored-players-${playerId}`} data-testid={`event-profile-v3.eligible-players-error.invalid-player-${playerId}`}>
                                            {playerId},
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                        {addEligiblePlayersErrors?.totalCreated > 0 && (
                            <div className="section-subtext text-left mt24 mb8" data-testid="event-profile-v3.eligible-players-error.success-msg">Remainder of players IDs successfully added</div>
                        )}
                        <button
                            type="button"
                            className="btn btn-primary btn-xl btn-block text-uppercase mt40"
                            onClick={handleCloseAddEligiblePlayerError}
                            data-testid="event-profile-v3.eligible-players-error.ok-btn"
                        >
                            OK
                        </button>
                    </GenericPopUp>
                )}
                {showSendPreRegistrantInviteError && (
                    <PopupV3
                        className={`popup-md`}
                        onCloseClick={handleClosePreRegistrantInviteError}
                        title={preRegistrantInviteErrors?.totalCreated > 0 ? `Some Players Couldn't Be Invited` : 'No Players Were Invited'}
                        type={PopupTypes.ERROR}
                        isOpen={showSendPreRegistrantInviteError}
                        message={(
                            <>
                                {preRegistrantInviteErrors?.totalCreated > 0 ? (
                                    <div className="mb16" data-testid="event-profile-v3.prereg-invite-error.partial-msg">While some players were successfully invited, we encountered an issue with the following IDs:</div>
                                ) : (
                                    <div className="mb16" data-testid="event-profile-v3.prereg-invite-error.none-msg">The following IDs could not be invited:</div>
                                )}
                                {preRegistrantInviteErrors?.invalidPlayersForDivisionCategoryGender?.length > 0 && (
                                    <div className="mb8" data-testid="event-profile-v3.prereg-invite-error.gender-section">
                                        <div className="" data-testid="event-profile-v3.prereg-invite-error.gender-label">Gender</div>
                                        <div className="text-bold">
                                            {preRegistrantInviteErrors.invalidPlayersForDivisionCategoryGender.map(player => player.playerId).join(', ')}
                                        </div>
                                    </div>
                                )}
                                {preRegistrantInviteErrors?.unclaimedPlayers?.length > 0 && (
                                    <div className="mb8" data-testid="event-profile-v3.prereg-invite-error.unclaimed-section">
                                        <div className="" data-testid="event-profile-v3.prereg-invite-error.unclaimed-label">Unclaimed</div>
                                        <div className="text-bold">
                                            {preRegistrantInviteErrors.unclaimedPlayers.map(player => player.playerId).join(', ')}
                                        </div>
                                    </div>
                                )}
                                {preRegistrantInviteErrors?.invalidPlayerIds?.length > 0 && (
                                    <div className="" data-testid="event-profile-v3.prereg-invite-error.invalid-section">
                                        <div className="" data-testid="event-profile-v3.prereg-invite-error.invalid-label">Invalid</div>
                                        <div className="text-bold">
                                            {preRegistrantInviteErrors.invalidPlayerIds.join(', ')}
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                        confirmButtonLabel={`OK`}
                        onConfirmClick={handleClosePreRegistrantInviteError}
                        customContent
                    />
                )}
                {showInvitePreRegistrantsSidebar && !preRegMedalInvitesEnabled && (
                    <SidebarInvitePreRegistrants
                        eventId={event.data?.id}
                        registrationStartDate={event.data?.eventSchedule?.registrationStartUtc}
                        timeZone={event.data?.eventSchedule?.timeZone}
                        divisions={event.data?.eventDivisions}
                        preRegFilterOptions={preRegFilterOptions?.data}
                        preRegStats={preRegStats?.data}
                        onClose={toggleInvitePreRegistrantsSidebar}
                        onSubmitSuccess={onSendPreRegistrantInvitationsSuccess}
                    />
                )}
                {showInvitePreRegistrantsSidebar && preRegMedalInvitesEnabled && (
                    <SidebarInvitePreRegistrantsV2
                        eventId={event.data?.id}
                        registrationStartDate={event.data?.eventSchedule?.registrationStartUtc}
                        timeZone={event.data?.eventSchedule?.timeZone}
                        divisions={event.data?.eventDivisions}
                        preRegFilterOptions={preRegFilterOptions?.data}
                        preRegStats={preRegStats?.data}
                        onClose={toggleInvitePreRegistrantsSidebar}
                        onSubmitSuccess={onSendPreRegistrantInvitationsSuccess}
                    />
                )}
                {showRegClosedPopup && (
                    <PopupV3
                        title={`Registration is Now Closed`}
                        message={`Registration ended on ${moment
                            .utc(event?.data?.eventSchedule?.registrationEndUtc)
                            .local()
                            .format('MMM D, [at] h:mmA')}.`}
                        confirmButtonLabel={`Close`}
                        onConfirmClick={() => {
                            setShowRegClosedPopup(false);
                            loadEvent();
                        }}
                        showCancelButton={false}
                        isOpen
                    />
                )}
                {showTennisAustraliaIdModal && (
                    <TennisAustraliaIdModal
                        onClose={() => setShowTennisAustraliaIdModal(false)}
                        onContinue={handleTennisAustraliaLinkContinue}
                        data-testid="modal.ta-tennis-id"
                    />
                )}
            </div>
        );
    }

    return <SplashBall title="Event" description="Loading..." />;
}

EventProfilePageV3.propTypes = {
    location: routerLocationShape.isRequired,
    match: routerMatchShape.isRequired,
    history: routerHistoryShape.isRequired,
    auth: authShape.isRequired,
    isWebView: PropTypes.bool,
};

EventProfilePageV3.defaultProps = {
    isWebView: false,
};

export default EventProfilePageV3;
